import { render, staticRenderFns } from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=template&id=0428ab17&"
import script from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarHorizontalLayoutBrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports